import { generatePath } from "react-router-dom";
import { apiRoutes } from "../apiRoutes";
import axios from "../appAxios";

export const getPublicUser = async (userId) => {
  const response = await axios.get(
    generatePath(apiRoutes.GET_PUBLIC_USER, { userId }),
  );
  // Backend wraps the DTO: { user: dto }
  return response.data?.user ?? response.data;
};

export const followUser = async (userId) => {
  const response = await axios.post(generatePath(apiRoutes.FOLLOW_USER, { userId }));
  return response.data;
};

export const unfollowUser = async (userId) => {
  const response = await axios.delete(generatePath(apiRoutes.FOLLOW_USER, { userId }));
  return response.data;
};

export const followShop = async (shopId) => {
  const response = await axios.post(generatePath(apiRoutes.FOLLOW_SHOP, { shopId }));
  return response.data;
};

export const unfollowShop = async (shopId) => {
  const response = await axios.delete(generatePath(apiRoutes.FOLLOW_SHOP, { shopId }));
  return response.data;
};

export const getUserShops = async (userId) => {
  const response = await axios.get(
    generatePath(apiRoutes.GET_USER_SHOPS, { userId }),
  );
  return response.data;
};

export const updateUserProfile = async (profileData) => {
  const response = await axios.patch(apiRoutes.UPDATE_USER_PROFILE, profileData);
  return response.data;
};

export const uploadProfilePhoto = async (file) => {
  const formData = new FormData();
  formData.append("profilePhoto", file);
  const response = await axios.post(apiRoutes.UPLOAD_PROFILE_PHOTO, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const uploadCoverPhoto = async (file) => {
  const formData = new FormData();
  formData.append("coverPhoto", file);
  const response = await axios.post(apiRoutes.UPLOAD_COVER_PHOTO, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const addExperience = async (data) => {
  const response = await axios.post(apiRoutes.ADD_EXPERIENCE, data);
  return response.data;
};

export const updateExperience = async ({ experienceId, ...data }) => {
  const response = await axios.patch(
    generatePath(apiRoutes.UPDATE_EXPERIENCE, { experienceId }),
    data,
  );
  return response.data;
};

export const deleteExperience = async (experienceId) => {
  const response = await axios.delete(
    generatePath(apiRoutes.DELETE_EXPERIENCE, { experienceId }),
  );
  return response.data;
};

export const searchInstitutions = async ({ q, type = "education" }) => {
  const response = await axios.get(apiRoutes.SEARCH_INSTITUTIONS, { params: { q, type } });
  return response.data.suggestions;
};

export const addEducation = async (data) => {
  const response = await axios.post(apiRoutes.ADD_EDUCATION, data);
  return response.data;
};

export const updateEducation = async ({ educationId, ...data }) => {
  const response = await axios.patch(
    generatePath(apiRoutes.UPDATE_EDUCATION, { educationId }),
    data,
  );
  return response.data;
};

export const deleteEducation = async (educationId) => {
  const response = await axios.delete(
    generatePath(apiRoutes.DELETE_EDUCATION, { educationId }),
  );
  return response.data;
};
